import axios from 'axios';
import { getClerkSessionToken } from '@/services/clerk';

const apiUrl = process.env.VUE_APP_NODE_ENV === 'production'
  ? process.env.VUE_APP_PROD_API_URL
  : process.env.VUE_APP_DEV_API_URL;

const accountsPayableApi = axios.create({
  baseURL: `${apiUrl.replace(/\/$/, '')}/api`,
  headers: { 'Content-Type': 'application/json' },
});

async function postAuthorized(path, payload) {
  const sessionToken = await getClerkSessionToken();

  if (!sessionToken) {
    throw new Error('You must be signed in to manage accounts payable.');
  }

  const response = await accountsPayableApi.post(path, payload, {
    headers: { Authorization: `Bearer ${sessionToken}` },
  });
  return response.data;
}

export function previewAccountsPayable(invoiceDate, jobsLimitDate) {
  return postAuthorized('/accounts-payable/preview', { invoiceDate, jobsLimitDate });
}

export function generateAccountsPayable(invoiceDate, jobsLimitDate) {
  return postAuthorized('/accounts-payable/generate', { invoiceDate, jobsLimitDate });
}

export function sendAccountsPayable(accountsPayableId) {
  return postAuthorized(
    `/accounts-payable/${encodeURIComponent(accountsPayableId)}/send`,
    {},
  );
}

export function previewSecureLinkBackfill(limit = 3) {
  return postAuthorized('/accounts-payable/secure-links/preview', { limit });
}

export function backfillSecureLinks(limit = 3) {
  return postAuthorized('/accounts-payable/secure-links/backfill', { limit });
}

export async function fetchPublicAccountsPayable(recordId, token) {
  const response = await accountsPayableApi.get(
    `/public/accounts-payable/${encodeURIComponent(recordId)}`,
    { params: { token } },
  );
  return response.data;
}
